/** logic.js:139-143 TOUR, verbatim. */
export interface OEPTourStep { Title: string; Body: string }
export const OEP_TOUR: readonly OEPTourStep[] = [
    { Title: 'Everything OEP, in one place', Body: 'Drafts, feedback, nominations and winner selection all live here now. One sign in, one place to look.' },
    { Title: 'Your roles appear when it is their turn', Body: 'You may be a reviewer, a nominator and a committee member across one season. We only show you the role that is active, the rest stay quiet until their window opens.' },
    { Title: 'We will always tell you what is next', Body: 'Your home page leads with what needs you now and its deadline, with the right guidance sitting beside it. Anything already done moves out of the way.' },
];

/** UserInfoEngine setting: present (any value) once the user has finished or skipped the tour. UBP §7. */
export const OEP_TOUR_SETTING = 'oep.tour.v1';
export const OEP_TOUR_DONE = 'done';

/** logic.js:768 — "Step 1 of 3". */
export function TourStepLabel(step: number): string {
    return `Step ${step + 1} of ${OEP_TOUR.length}`;
}

/** logic.js:772 — "Next", and "Get started" on the last step. */
export function TourNextLabel(step: number): string {
    return step === OEP_TOUR.length - 1 ? 'Get started' : 'Next';
}

export function IsLastTourStep(step: number): boolean {
    return step === OEP_TOUR.length - 1;
}

/** The tour opens only for a user with no stored setting. */
export function ShouldShowTour(stored: string | undefined): boolean {
    return stored === undefined;
}
